import { Stack, Box, Skeleton } from '@mui/material'

const LoginSkeleton = () => (
  <>
    <Stack gap={2} direction="column">
      <Box>
        <Skeleton variant="text" height={30} width="20%" />
        <Skeleton variant="rectangular" height={40} />
      </Box>

      <Box>
        <Skeleton variant="text" height={30} width="20%" />
        <Skeleton variant="rectangular" height={40} />
      </Box>
    </Stack>

    <Box display="flex" justifyContent="center" marginBottom={4}>
      <Skeleton variant="text" height={30} width="30%" />
    </Box>

    <Skeleton variant="rectangular" height={40} />
  </>
)

export default LoginSkeleton
